/* @flow */

import _StepProgressBar from './StepProgressBar';

export default _StepProgressBar;



// WEBPACK FOOTER //
// ./src/components/StepProgressBar/index.js